export const DEFAULT_LOCALE: string = "en"
